import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-265b680a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "space-between" }
const _hoisted_3 = { class: "logo_wrap" }
const _hoisted_4 = { class: "c_logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_7 = { class: "key-container" }
const _hoisted_8 = { class: "deal-title" }
const _hoisted_9 = { class: "deal-name bold large" }
const _hoisted_10 = { class: "deal_details" }
const _hoisted_11 = { class: "small" }
const _hoisted_12 = { class: "status name" }
const _hoisted_13 = { class: "deal_center" }
const _hoisted_14 = { class: "price-info" }
const _hoisted_15 = { class: "deals-price" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "price-info" }
const _hoisted_18 = { class: "deals-price" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_22 = { class: "price-info" }
const _hoisted_23 = { class: "deals-price" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "거래 금액", -1))
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1))
const _hoisted_28 = { class: "price-info" }
const _hoisted_29 = { class: "deals-price" }
const _hoisted_30 = { class: "name" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_32 = { class: "price-info" }
const _hoisted_33 = { class: "result-price" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "손익", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "0", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 원 (0%) ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 확인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_header, { handle: true }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.deal.partnershipLogo ? _ctx.deal.partnershipLogo : '/assets/icon/company_default_img.png',
                  onerror: "this.src='/assets/icon/company_default_img.png'",
                  class: "img-responsive img-circle"
                }, null, 8, _hoisted_5),
                _hoisted_6
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.deal.partnershipName), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(_ctx.deal.createAt)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ blue: _ctx.deal.type === '구매', mint: _ctx.deal.type === '판매'})
                  }, _toDisplayString(_ctx.deal.type), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.deal.type === '판매' ? '판매 금액' : '구매 금액'), 1),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.deal.totalPrice)), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.deal.qty)) + " 주) ", 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.deal.type === '판매' ? '수수료 + 성과보수' : '수수료'), 1),
                    _withDirectives(_createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency((_ctx.deal.fee ? +_ctx.deal.fee : 0) + (_ctx.deal.carriedInterest ? +_ctx.deal.carriedInterest : 0))), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_20
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.deal.type === '판매']
                    ]),
                    _withDirectives(_createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.deal.fee ? +_ctx.deal.fee : 0)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_21
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.deal.type === '구매']
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.currency(_ctx.transactionPrice)), 1),
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(`주당 ${_ctx.deal.type} 가격`), 1),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.deal.price)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    (_ctx.deal.profit === '0')
                      ? (_openBlock(), _createBlock(_component_ag_text, {
                          key: 0,
                          typography: "main16r"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_35,
                            _hoisted_36
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.deal.profit > 0)
                      ? (_openBlock(), _createBlock(_component_ag_text, {
                          key: 1,
                          color: "danger",
                          typography: "main16r"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                              default: _withCtx(() => [
                                _createTextVNode(" + " + _toDisplayString(_ctx.$filters.currency(_ctx.deal.profit)), 1)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.deal.profitRate)) + "%) ", 1)
                          ]),
                          _: 1
                        }))
                      : (_ctx.deal.profit < 0)
                        ? (_openBlock(), _createBlock(_component_ag_text, {
                            key: 2,
                            color: "primary",
                            typography: "main16r"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.deal.profit)), 1)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.deal.profitRate)) + "%) ", 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, _ctx.deal.profit || _ctx.deal.type === '판매']
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_button, {
          corner: "10px",
          width: "100%",
          onClickCapture: _ctx.dismiss
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }, 8, ["onClickCapture"])
      ]),
      _: 1
    })
  ], 64))
}